import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialState = () => {
  return { user: null, permissions: [] };
};

export default {
  namespaced: true,
  state: initialState(),
  mutations,
  actions,
  getters,
};
